<template>
  <div class="card-body">
    <h3 class="h5">{{ trans('dashboard.account.profile.title') }}</h3>
    <div class="alert alert-success" v-if="profileLanguageForm.wasSuccessful">
      {{ trans('dashboard.alerts.success_update_profile_language') }}
    </div>

    <label class="form_label">{{ trans('common.profile_photo') }}</label>

    <form role="form">
      <div class="form-group">
        <div class="col-md-6 d-flex align-items-center">
          <label class="image-placeholder mr-4" for="choose-photo">
            <span role="img" class="profile-photo-preview" :style="previewStyle"></span>
          </label>
          <div class="spark-uploader mr-4">
            <input ref="photo" type="file" class="spark-uploader-control" name="photo" @input="submitProfilePhotoForm"
                   :disabled="profilePhotoForm.processing" id="choose-photo">
            <form-button class="button_secondary" :value="trans('dashboard.account.profile.update_photo')"
                         :processing-value="trans('common.updating')" :processing="profilePhotoForm.processing"/>
          </div>
        </div>
        <div>
          <input type="hidden" class="form-control" :class="{'is-invalid': profilePhotoForm.errors.photo}">
          <span class="invalid-feedback" v-show="profilePhotoForm.errors.photo">
              {{ profilePhotoForm.errors.photo }}
            </span>
        </div>
      </div>
    </form>

    <form role="form" @submit.prevent="submitProfileLanguageForm">
      <!-- Profile Language -->
      <form-input id="user-profile_language"
                  name="profile_language"
                  type="select"
                  v-model="profileLanguageForm.locale"
                  container-class="form-group"
                  :label-text="trans('common.profile_language')"
                  :options="locales"
                  :allow-empty="false"
                  track-by="code"
                  label="name"
                  :error="profileLanguageForm.errors.locale"/>

      <!-- Update Button -->
      <div class="form_row">
        <span></span>

        <form-button :value="trans('common.update')" :processing="profileLanguageForm.processing"/>
      </div>
    </form>
  </div>
</template>

<script>
import {computed} from "vue";
import {useForm} from "@inertiajs/vue3";
import FormButton from "@/components/Shared/Form/Button";
import FormInput from "@/components/Shared/Form/Input/Index";

export default {
  name: "ProfileForm",
  components: {FormInput, FormButton},

  props: {
    user: Object,
    locales: Array
  },

  setup(props) {
    const profilePhotoForm = useForm({
      photo: null
    })

    const profileLanguageForm = useForm({
      locale: props.locales.find(locale => locale.code === props.user.profile_language)
    })

    const previewStyle = computed(() => `background-image: url(${props.user.photo_url ?? '/images/05.jpg'})`);

    return {profilePhotoForm, profileLanguageForm, previewStyle}
  },

  methods: {
    submitProfilePhotoForm(event) {
      let file = event.target.files[0];

      if (!file) {
        return
      }

      this.profilePhotoForm
        .transform((data) => ({
          ...data,
          photo: file,
          _method: 'put'
        }))
        .post(this.$route('dashboard.account.profile.picture.update'))
    },

    submitProfileLanguageForm() {
      this.profileLanguageForm
        .transform((data) => ({
          ...data,
          locale: data.locale?.code
        }))
        .put(this.$route('dashboard.account.profile.language.update'))
    }
  }
}
</script>
